<script setup>
import { onBeforeMount, onBeforeUnmount, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

import { useUserStore } from "@/_store/userStore.js";
const userStore = useUserStore();
const router = useRouter();

import ArgonInput from "@/components/ArgonInput.vue";
import { ArgonLoadingButton } from "@/components";
import ArgonSnackbar from "@/components/ArgonSnackbar.vue";
import { errorUtils } from "@/utils";


import { useVuelidate } from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";

const body = document.getElementsByTagName("body")[0];

const store = useStore();
const toggleDefaultLayout = () => store.commit("toggleDefaultLayout");

const rules = {
  user: { required: helpers.withMessage("Email es requerido", required), email: helpers.withMessage("Ingrese un email valido", email) },
};

const data = ref({
  user: "",
})
const v$ = ref(useVuelidate(rules, data));
const loading = ref(false);
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  toggleDefaultLayout();
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  toggleDefaultLayout();
  body.classList.add("bg-gray-100");
});

function submit() {
  const resValidation = validate()
  resValidation.then((values) => {
    let message = "";
    for (const value of values) {
      message = `${message}<li>${value.$message}</li>`;
    }
    if (message != "") {
      snackbar.value = {
        title: "Error",
        message: `<ul>${message}</ul>`,
        type: "danger",
        color: "white",
      };
    } else {
      loading.value = true;
      userStore.getRecoverLink(data.value);
    }
  });
}
watch(
  () => userStore.linkRecover,
  (value) => {
    if (value) {
      loading.value = false;
      router.push({ path: "/recover/request-sended"});
    }
  }
);
watch(
  () => userStore.error,
  (value) => {
    if (value) {
      loading.value = false;
      snackbar.value = {
        title: "Error",
        message: errorUtils.getErrorMessageHtml(value),
        type: "danger",
        color: "white",
      };
    }
  }
);
async function validate() {
  await v$.value.$validate();
  return v$.value.$errors;
}
const snackbar = ref(null);
const closeSnackbar = () => {
  snackbar.value = null;
};
</script>
<template>
  <main class="mt-0 main-content card-detail-layout">
    <section>
      <div
class="page-header min-vh-100" :style="{
        backgroundImage: 'url(' + '/img/logos/public-back-ground.png' + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }">
        <span class="mask bg-primary opacity-3"></span>
        <div class="container text-center">
          <div class="row justify-content-md-center mb-6">
            <div class="w-50">
              <img class="img-fluid" src="/img/logos/beedelivery_logo.png" alt="logo" />
            </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card">
                <div class="card-header text-center">
                  <h3 class="font-weight-bolder">Restablecer Contraseña</h3>
                  <p class="mb-0">
                    Introduzca su correo de usuario, le enviaremos un email con instrucciones sobre cómo restablecer su
                    contraseña.
                  </p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="submit">
                    <div class="mb-3">
                      <argon-input
id="email" v-model="data.user" :max-length="75" type="text" placeholder="Email"
                        name="email" size="lg" :error="v$.user.$error" />
                    </div>
                    <div class="text-center">
                      <argon-loading-button
class="mt-4 mb-4" color="primary" variant="gradient"
             :label="loading ? 'Enviando...' : 'Enviar'" :loading="loading" full-width size="lg"></argon-loading-button>                      
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </section>
  </main>
  <div class="position-fixed top-1 end-1 z-index-2">
    <argon-snackbar
v-if="snackbar" :title="snackbar.title" :description="snackbar.message"
      :icon="{ component: 'ni ni-notification-70', color: snackbar.type }" :color="snackbar.color"
      :close-handler="closeSnackbar" />
  </div>
</template>
